import DOMPurify from 'dompurify';

const EMAIL_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  's',
  'strike',
  'u',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'span',
  'div',
];

const EMAIL_ALLOWED_ATTR = ['style'];

const HTML_TAG_PATTERN = /<[a-z][\s\S]*>/i;

export function sanitizeBlockHtml(html: string): string {
  if (!html?.trim()) {
    return '';
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: EMAIL_ALLOWED_TAGS,
    ALLOWED_ATTR: EMAIL_ALLOWED_ATTR,
  });
}

export function plainTextToHtml(text: string): string {
  if (!text) {
    return '';
  }

  if (HTML_TAG_PATTERN.test(text)) {
    return sanitizeBlockHtml(text);
  }

  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br>');
}

export function blockTextToTipTapContent(text: string, blockType: 'text' | 'title'): string {
  const inner = plainTextToHtml(text);
  return inner ? `<p>${inner}</p>` : '<p></p>';
}

export function tipTapHtmlToBlockText(html: string, _blockType: 'text' | 'title'): string {
  const trimmed = html?.trim();
  if (!trimmed) {
    return '';
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(trimmed, 'text/html');
  const root = doc.body.querySelector('p, h2');

  if (root) {
    return sanitizeBlockHtml(root.innerHTML);
  }

  return sanitizeBlockHtml(trimmed);
}
